import { render, staticRenderFns } from "./MessageAlert.vue?vue&type=template&id=650fd294&scoped=true"
import script from "./MessageAlert.vue?vue&type=script&lang=js"
export * from "./MessageAlert.vue?vue&type=script&lang=js"
import style0 from "./MessageAlert.vue?vue&type=style&index=0&id=650fd294&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650fd294",
  null
  
)

export default component.exports